import PropTypes from 'prop-types';

export const FlowShape = {
  id: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  version: PropTypes.number.isRequired,
  enabled: PropTypes.bool
};
